var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.773 71.379l1.266-2.945c1.367 1.023 3.18 1.554 4.973 1.554 1.328 0 2.16-.511 2.16-1.289-.02-2.164-7.93-.469-7.988-5.906-.02-2.758 2.425-4.887 5.89-4.887 2.059 0 4.117.512 5.586 1.68l-1.183 3.004c-1.344-.86-3.016-1.473-4.606-1.473-1.082 0-1.793.512-1.793 1.164.02 2.125 7.988.961 8.07 6.153 0 2.82-2.382 4.804-5.808 4.804-2.508 0-4.813-.593-6.567-1.86m48.5-4.007a3.647 3.647 0 01-6.828-1.797 3.65 3.65 0 013.649-3.66c1.363 0 2.547.758 3.18 1.86l3.484-1.942c-1.305-2.328-3.813-3.926-6.664-3.926-4.223 0-7.645 3.438-7.645 7.668s3.422 7.664 7.645 7.664a7.591 7.591 0 006.664-3.926l-3.485-1.94zM59.902 51.55h4.364v21.403h-4.364V51.551zm39.571 0v21.403h4.359v-6.418l5.18 6.418h5.586l-6.586-7.625 6.097-7.113h-5.343l-4.934 5.906v-12.57h-4.36zM77.23 67.414c-.632 1.043-1.937 1.816-3.406 1.816a3.65 3.65 0 01-3.648-3.656 3.653 3.653 0 013.648-3.66c1.469 0 2.774.816 3.406 1.879v3.621zm0-9.2v1.74c-.714-1.208-2.488-2.048-4.343-2.048-3.832 0-6.848 3.395-6.848 7.645 0 4.254 3.016 7.687 6.848 7.687 1.855 0 3.629-.84 4.343-2.043v1.739h4.364v-14.72H77.23zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.805 67.39c0 1.493-1.203 2.7-2.692 2.7a2.693 2.693 0 01-2.691-2.7 2.69 2.69 0 012.691-2.695h2.692v2.696zm1.343 0a2.69 2.69 0 012.692-2.695 2.69 2.69 0 012.691 2.696v6.746a2.693 2.693 0 01-2.691 2.699 2.693 2.693 0 01-2.692-2.7v-6.745zm0 0",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.84 56.559a2.693 2.693 0 01-2.692-2.7 2.69 2.69 0 012.692-2.695 2.69 2.69 0 012.691 2.695v2.7H22.84zm0 1.371a2.69 2.69 0 012.691 2.695c0 1.492-1.203 2.7-2.691 2.7h-6.746a2.693 2.693 0 01-2.692-2.7 2.69 2.69 0 012.692-2.695h6.746zm0 0",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.625 60.625a2.69 2.69 0 012.691-2.695 2.69 2.69 0 012.692 2.695c0 1.492-1.203 2.7-2.692 2.7h-2.691v-2.7zm-1.344 0c0 1.492-1.203 2.7-2.691 2.7a2.693 2.693 0 01-2.692-2.7v-6.766a2.69 2.69 0 012.692-2.695 2.69 2.69 0 012.691 2.695v6.766zm0 0",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.59 71.441a2.69 2.69 0 012.691 2.696 2.693 2.693 0 01-2.691 2.699 2.693 2.693 0 01-2.692-2.7v-2.695h2.692zm0-1.351a2.693 2.693 0 01-2.692-2.7 2.69 2.69 0 012.692-2.695h6.746a2.69 2.69 0 012.691 2.696 2.693 2.693 0 01-2.691 2.699H29.59zm0 0",
    fill: "#ECB22E"
  }));
};